import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getShops } from "actions/shopActions";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const SelectShop = ({ getShops, onChange }) => {
    const { t } = useTranslation();
    const [shops, setShops] = useState([]);
    const [shop, setShop] = useState("");

    useEffect(() => {
        getShops({ sizeperpage: 1000 }).then((data) => {
            setShops(data?.shops?.map((shop) => ({ value: shop._id, label: `${shop?.name} (${shop?.note}) - ${shop?.region} - ${shop?.code}` })) || []);
        });
    }, [getShops]);

    return (
        <Select
            isClearable
            name="filter_shop"
            options={shops}
            value={shops.filter(({ value }) => value === shop)}
            className="basic-multi-select al-custom-select-search-variants al-filter-table"
            classNamePrefix="select"
            onChange={(data) => {
                setShop(data?.value || "");
                onChange?.(data?.value || "");
            }}
            placeholder={t(`Select a shop ... `)}
            styles={{
                menu: (provided) => ({
                    ...provided,
                    minWidth: "450px",
                    zIndex: "9999"
                }),
                menuList: (provided) => ({
                    ...provided,
                    paddingBottom: "0px"
                }),
            }}
        />
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = { getShops };

export default connect(mapStateToProps, mapDispatchToProps)(SelectShop);
